import styled from 'styled-components';
import { StyledNewsMiniatureProps } from './NewsMiniature.types';

export const StyledNewsMiniature = styled.div<StyledNewsMiniatureProps>`
  background-image: url(${(props) => props.backgroundImageUrl});
  background-size: cover;
  overflow: hidden;

  ${(props) => props.customStyle}
`;
